<template>
  <a
    :href="'#comment-' + officialAnswer.id"
    v-if="officialAnswer"
    class="bg-white mt-3 flex flex-col"
  >
    <div class="bg-theme-secondary/30 p-0.5 uppercase text-sm text-center tracking-wider">
      {{ $t('spotdetail.comments_official_answer') }}
    </div>
    <div
      class="flex flex-col gap-1 p-2 border-y-theme-secondary border-y-[1px]"
    >
      <div class="flex gap-1 items-center">
        <UserImage :imageId="officialAnswer.user?.profileImageId" />
        <div>
          <div class="flex gap-1">
            <p class="font-semibold">
              {{
                officialAnswer.user?.organizationName
                  ? officialAnswer.user?.organizationName
                  : officialAnswer.user?.userName
              }}
            </p>
            <img
              v-if="officialAnswer.user?.verified"
              src="~assets/icon/verified.svg"
              :alt="$t('accessibility.verified')"
            />
          </div>
          <p class="text-sm">
            {{ $d(new Date(officialAnswer.createdOn), 'short') }}
          </p>
        </div>
      </div>
      <p>
        {{ officialAnswer.text }}
      </p>
      <div
        class="flex justify-end"
        v-if="loggedIn && user?.official && user?.id == officialAnswer.user?.id"
      >
        <ButtonPrimary :small="true" @click="openModal()"
          >{{ $t('spotdetail.comments_remove_official_answer') }}
        </ButtonPrimary>
        <Modal :id="'remove_official_answer_modal-' + officialAnswer.id">
          <div class="flex flex-col gap-2">
            <h2>{{ $t('spotdetail.comments_remove_official_answer') }}</h2>
            <p>
              {{
                $t('spotdetail.comments_remove_official_answer_caution_text')
              }}
            </p>
            <ButtonSubmit
              :small="true"
              :title="$t('spotdetail.comments_remove_official_answer')"
              @click="unmarkAsOfficialAnswer()"
              :loading="loading"
              :error="error"
            />
          </div>
        </Modal>
      </div>
    </div>
  </a>
</template>
<script setup lang="ts">
const { $api } = useNuxtApp();

const { t } = useI18n();
const props = defineProps<{ spot: SpotDetail; officialAnswer: Comment }>();
const loading = ref(false);
const error = ref(false);
const { loggedIn, user } = useUserSession();

const nuxtApp = useNuxtApp()

function openModal() {
  const modal = document.getElementById(
    'remove_official_answer_modal-' + props.officialAnswer.id
  ) as HTMLFormElement;
  if (modal) {
    modal.show();
  }
}

function unmarkAsOfficialAnswer() {
  loading.value = true;
  error.value = false;

  const url =
    '/spots/' +
    props.spot.id +
    '/comments/' +
    props.officialAnswer.id.toString() +
    '/unmarkOfficial';

  $api<boolean>(url)
    .then(() => {
      props.spot.officialAnswer = undefined;
    })
    .catch(() => {
      error.value = true;
    })
    .finally(() => {
      loading.value = false;
    });
}
</script>
